<template>
  <DxDataGrid
    :data-source="data"
    :show-borders="true"
  >
    <DxHeaderFilter
      :visible="true"
    />
    <DxExport
      :enabled="true"
      :allow-export-selected-data="false"
    />
    <DxSearchPanel
      :visible="true"
      :width="240"
      placeholder="Search..."
    />

    <DxColumn
      v-for="(column, index) in dataColumns"
      :key="index"
      :width="column.width"
      :data-field="column.dataField"
      :caption="column.caption"
      :data-type="column.dataType"
      :visible="column.visible"
    ></DxColumn>
    <DxColumn
      v-if="link"
      :allow-sorting="false"
      cell-template="cellTemplateButtons"
    />
    <template #cellTemplateButtons="dataTemplate">
      <div>

        <vs-button
          :to="{name: link, params: { id: dataTemplate.data.data.id }}"
          depressed
          color="#5E72E4"
          dark
          class="font-weight-bold"
        >
          <vs-icon icon="person"/>
          Ver detalle
        </vs-button>


        <vs-button
          class="ml-3"
          :to="{name: link, params: { id: dataTemplate.data.data.id }}"
        >
          <!--                    <font-awesome-icon :icon="['fas', 'pen']"/>-->
          <vs-icon icon="person"/>
        </vs-button>
      </div>
    </template>

    <DxColumnChooser :enabled="true"/>
    <DxFilterRow :visible="true"/>
    <DxPaging :page-size="15"/>
    <DxPager
      :show-info="true"
      :show-navigation-buttons="true"
      :show-page-size-selector="true"
      :allowed-page-sizes="[15, 25, 50]"
    />

  </DxDataGrid>
</template>

<script>
  import {
    DxColumn, DxColumnChooser,
    DxDataGrid,
    DxFilterRow,
    DxHeaderFilter,
    DxPager, DxExport,
    DxPaging, DxSearchPanel
  } from 'devextreme-vue/data-grid';
  import esMessages from 'devextreme/localization/messages/es.json';
  import {locale, loadMessages} from 'devextreme/localization';

  export default {
    components: {
      DxDataGrid,
      DxColumn,
      DxPaging,
      DxFilterRow,
      DxPager,
      DxHeaderFilter,
      DxSearchPanel,
      DxColumnChooser,
      DxExport
    },
    props: ['data', 'dataColumns', 'link'],
    data () {
      return {}
    },
    created () {
      loadMessages(esMessages);
      locale('es');
    },
  }
</script>
